module.exports = "<section class=\"card\">\n  <div class=\"vertical-bar-left\"></div>\n  <div class=\"message-container\">\n   <span class=\"alert-message\">{{'FOOD_BENEFIT.HOME.WARN' | translate}}</span>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/food-benefit.module/components/lastDayAlert/lastDayAlert.html
// module id = 1685
// module chunks = 0